module.exports = __webpack_public_path__ + "img/logo_11.b63f7d91.png";